export default __webpack_public_path__ + "static/media/pop-white.2443c335.svg";